import { render, staticRenderFns } from "./ClientInputsTab.vue?vue&type=template&id=943499e4&scoped=true"
import script from "./ClientInputsTab.vue?vue&type=script&lang=js"
export * from "./ClientInputsTab.vue?vue&type=script&lang=js"
import style0 from "./ClientInputsTab.vue?vue&type=style&index=0&id=943499e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943499e4",
  null
  
)

export default component.exports